const primary = '#3a30af';

export default {
  primary,
}
